import { Dispatch, SetStateAction, useEffect, useState } from 'react';

export default function useLocalStorage<T>(
  key: string,
  initialValue: T,
): [T, (data: T) => void] {
  const [storedValue, setStoredValue] = useState(initialValue);
  const [firstLoadDone, setFirstLoadDone] = useState(false);

  useEffect(() => {
    const fromLocal = () => {
      if (typeof window === 'undefined') {
        return initialValue;
      }
      try {
        const item = window.localStorage.getItem(key);
        return item ? (JSON.parse(item) as T) : initialValue;
      } catch (error) {
        if (error instanceof Error) {
          console.log(`JSPERROR:106:${error.message}`);
        } else {
          console.log("JSPERROR:106", error);
        }
        return initialValue;
      }
    };

    setStoredValue(fromLocal);
    setFirstLoadDone(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const changeValue = (data: T) => {
    if (!firstLoadDone) {
      return;
    }

    try {
      if (typeof window !== 'undefined') {
        window.localStorage.setItem(key, JSON.stringify(data));
        window.dispatchEvent(new Event('changeShortList'));
      }
    } catch (error) {
      console.log(error);
    }
  }

  const getShortList = () => {
    try {
      setStoredValue(JSON.parse(window?.localStorage?.getItem(key) || '[]') as T);
    } catch (error) {
      if (error instanceof Error) {
        console.log(`JSPERROR:107:${error.message}`);
      } else {
        console.log(`JSPERROR:107:${error}`);
      }
    }
  }

  useEffect(() => {
    getShortList();

    window.addEventListener('changeShortList', () => {
      getShortList()
    })

    return () => {
      window.removeEventListener('changeShortList', () => {});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return [storedValue, changeValue];
}
